// src/pages/booking.js
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

export default function Booking() {
  useEffect(() => {
  const script = document.createElement("script");
  script.src = "https://links.equiptbiz.com/js/form_embed.js";
  script.type = "text/javascript";
  document.body.appendChild(script);
  return () => {
    document.body.removeChild(script);
  };
}, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>Schedule Your Free Strategy Call | Reflex Advisor</title>
        <meta name="description" content="Book your free strategy call with Reflex Advisor and start scaling your service business today." />
        <style>{`
          html, body { margin:0; padding:0; overflow-x:hidden; background:#fff; }
        `}</style>
      </Helmet>

      <div className="booking-page">


        <div className="booking-header">
          <p className="booking-eyebrow">Limited Spots Available This Week</p>
          <h1 className="booking-title">
            Schedule Your <span className="booking-highlight">Strategy Call</span>
          </h1>

          <div className="booking-meta">
            <span className="booking-hours">Mon–Friday · 9am–8pm PST</span>
            <span className="booking-dot">•</span>
            <a href="tel:+14375253445" className="booking-phone">+1 437 525 3445</a>
          </div>
        </div>

        <div className="booking-calendar-wrap">
          <iframe
  src="https://links.equiptbiz.com/widget/booking/uTzzkuYXR4MR0pTDbbFp"
  className="booking-calendar"
  title="Schedule Meeting"
  scrolling="no"
  id="uTzzkuYXR4MR0pTDbbFp_1782747195262"
/>
        </div>

      </div>

      <style>{`
        .booking-page {
          position: relative;
          width: 100%;
          min-height: 100vh;
          background: #fff;
          font-family: -apple-system, 'SF Pro Text', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
          display: flex;
          flex-direction: column;
          align-items: center;
          box-sizing: border-box;
          padding: 80px 24px 90px;
          overflow: hidden;
        }

        .booking-header {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          max-width: 720px;
          margin-bottom: 48px;
        }

        .booking-eyebrow {
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #d18cf3;
          margin: 0 0 20px;
          padding: 8px 18px;
          border: 1px solid rgba(123,25,188,0.4);
          border-radius: 980px;
          background: rgba(123,25,188,0.08);
        }

        .booking-title {
          font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
          font-size: 46px;
          font-weight: 700;
          line-height: 1.15;
          letter-spacing: -0.03em;
          color: #0a0a0a;
          margin: 0 0 22px;
        }

        .booking-highlight {
          background: linear-gradient(90deg, #a855f7, #d18cf3, #7b19bc);
          background-size: 200% auto;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: shimmer 3s linear infinite;
        }

        @keyframes shimmer {
          0% { background-position: 0% center; }
          100% { background-position: 200% center; }
        }

        .booking-sub {
          font-size: 17px;
          font-weight: 400;
          color: rgba(255,255,255,0.65);
          line-height: 1.65;
          margin: 0 0 28px;
          max-width: 560px;
        }

        .booking-meta {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 14px;
          font-weight: 600;
          color: rgba(0,0,0,0.5);
        }

        .booking-dot { color: rgba(0,0,0,0.25); }

        .booking-phone {
          color: #d18cf3;
          text-decoration: none;
          font-weight: 700;
          transition: color 0.2s ease;
        }

        .booking-phone:hover { color: #7b19bc; }

        .booking-calendar-wrap {
          position: relative;
          z-index: 1;
          width: 100%;
          max-width: 920px;
          border-radius: 20px;
          overflow: hidden;
          background: #fff;
          box-shadow: 0 20px 60px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.06);
        }

        .booking-calendar {
          width: 100%;
          height: 700px;
          border: none;
          display: block;
        }

        @media (max-width: 768px) {
          .booking-title { font-size: 32px; }
          .booking-sub { font-size: 15px; }
          .booking-meta { flex-direction: column; gap: 6px; }
          .booking-dot { display: none; }
          .booking-calendar { height: 620px; }
        }

        @media (max-width: 480px) {
          .booking-title { font-size: 26px; }
          .booking-page { padding: 60px 16px 70px; }
        }
      `}</style>
    </React.Fragment>
  );
}